import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../services/api';

const states = ['case_received', 'work_started', 'in_progress', 'trial_ready', 'final_work_ready', 'dispatched', 'correction_in_progress', 'repair_in_progress', 'remake_in_progress', 'ready_after_correction', 'ready_after_repair', 'ready_after_remake', 'on_hold'];

export default function PublicLabUpdate() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [forms, setForms] = useState({});
  const [error, setError] = useState('');

  const load = () => api.get(`/public/lab-update/${token}`).then(({ data: next }) => setData(next));
  useEffect(() => { api.get(`/public/lab-update/${token}`).then(({ data: next }) => setData(next)).catch((e) => setError(e.response?.data?.error || 'This progress link is invalid or no longer active.')); }, [token]);

  const submit = async (item) => {
    const form = forms[item.itemKey] || {};
    try {
      await api.post(`/public/lab-update/${token}/items/${item.itemKey}`, {
        status: form.status || item.currentStatus,
        expectedReadyDate: form.expectedReadyDate,
        notes: form.notes,
        idempotencyKey: globalThis.crypto?.randomUUID?.() || `${Date.now()}-${item.itemKey}`,
      });
      toast.success('Progress update saved.');
      await load();
    } catch (e) { toast.error(e.response?.data?.error || 'Could not save update.'); }
  };

  if (error) return <main className="min-h-screen bg-slate-50 p-6 text-center"><p className="mx-auto max-w-md rounded-xl bg-rose-50 p-5 text-rose-700">{error}</p></main>;
  if (!data) return <main className="p-8 text-center">Loading lab case…</main>;
  return <main className="min-h-screen bg-slate-50 p-4"><div className="mx-auto max-w-xl">
    <h1 className="text-2xl font-bold">Lab Progress Update</h1>
    <p className="mt-1 text-sm">{data.clinicName} · {data.caseReference} · Patient {data.patientInitials}</p>
    {data.items.map((item) => <article key={item.itemKey} className="mt-4 rounded-2xl border bg-white p-4">
      <h2 className="font-bold">{item.workDescription}</h2>
      <p className="text-sm">Tooth/Region: {item.toothRegion} · Quantity {item.quantity}</p>
      <p className="mt-1 text-xs">Revision {item.currentRevisionNumber} · Instructions: {item.specialInstructions || 'None'}</p>
      <label className="mt-4 block text-sm font-semibold">Progress status<select value={forms[item.itemKey]?.status || item.currentStatus} onChange={(e) => setForms({ ...forms, [item.itemKey]: { ...forms[item.itemKey], status: e.target.value } })} className="mt-1 w-full rounded-xl border p-3 text-base">{states.map((state) => <option key={state} value={state}>{state.replaceAll('_', ' ')}</option>)}</select></label>
      <label className="mt-3 block text-sm">Expected ready date<input type="date" value={forms[item.itemKey]?.expectedReadyDate || item.expectedReadyDate || ''} onChange={(e) => setForms({ ...forms, [item.itemKey]: { ...forms[item.itemKey], expectedReadyDate: e.target.value } })} className="mt-1 w-full rounded-xl border p-3" /></label>
      <label className="mt-3 block text-sm">Short update<textarea value={forms[item.itemKey]?.notes || ''} onChange={(e) => setForms({ ...forms, [item.itemKey]: { ...forms[item.itemKey], notes: e.target.value } })} className="mt-1 w-full rounded-xl border p-3" /></label>
      <button onClick={() => submit(item)} className="mt-4 w-full rounded-xl bg-teal-700 p-3 font-bold text-white">Submit Update</button>
    </article>)}
  </div></main>;
}
